import { observable, action, runInAction } from 'mobx'
import Api from '@api/xiu_yan/jukeTreasureApi'
import { message } from 'hljd'

class Store {
  num
  give

  @observable data = {}
  @observable disabled = false
  @action
  getDetails = async () => {
    const { num } = this
    let { data } = await Api.payPoint({ num })
    runInAction(() => {
      this.data = data
      if (data.wallet - data.pay_money > 0) {
        this.disabled = false
      } else {
        this.disabled = true
      }
    })
  }

  @action
  payWallet = async () => {
    const { num } = this
    let params = {
      num,
      agent: 'wallet',
      kind: 3,
      return_url: ''
    }
    let { success } = await Api.pay(params)
    if (success) {
      message.success('支付成功')
    }
  }

  @observable user_name = ''
  @observable user_idcard = ''
  @observable user_bankcard = ''
  @observable user_phone = ''

  @action
  changeField = type => e => {
    this[type] = e.target.value
  }

  @action
  payCard = async () => {
    const { user_name, user_idcard, user_bankcard, user_phone, num } = this

    if (!user_name || !user_idcard || !user_bankcard || !user_phone) {
      return message.warning('请填写完整')
    }

    let params = {
      num,
      user_name,
      user_idcard,
      user_bankcard,
      user_phone,
      agent: 'llpay',
      kind: 3,
      return_url: ''
    }
    let { success } = await Api.pay(params)
    if (success) {
      message.success('支付成功')
    }
  }
}
export default new Store()
